import { AppRole, DEFAULT_PANEL_ROLES } from '@shared/auth/enums/app-role.enum';
import { TabLink } from '@shared/interfaces/menu/tab-link.interface';

export const HeaderConfig: { [key: string]: TabLink } = {
  myJob: {
    name: 'Header.myJob',
    link: 'my-work',
    iconUrl: '/assets/img/dashboard-icon.svg',
    roles: DEFAULT_PANEL_ROLES
  },
  projects: {
    name: 'Header.projects',
    link: 'projects-list',
    iconUrl: '/assets/img/project-icon.svg',
    roles: DEFAULT_PANEL_ROLES
  },
  calendar: {
    name: 'Header.calendar',
    link: 'calendar',
    iconUrl: '/assets/img/calendar-icon.svg',
    roles: DEFAULT_PANEL_ROLES
  },
  contacts: {
    name: 'Header.contacts',
    link: 'contacts-list',
    iconUrl: '/assets/img/contact-icon.svg',
    roles: [AppRole.ADMIN, AppRole.MANAGER]
  },
  gallery: {
    name: 'Header.gallery',
    link: 'gallery',
    iconUrl: '/assets/img/gallery-icon.svg',
    roles: DEFAULT_PANEL_ROLES
  },
  siteDiaries: {
    name: 'Header.siteDiaries',
    link: 'site-diaries',
    iconUrl: '/assets/img/ic-project-diary-white.svg'
  }
};
